import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import DashboardMetrics from '../components/dashboard/DashboardMetrics';
import DashboardCharts from '../components/dashboard/DashboardCharts';
import QuickActions from '../components/dashboard/QuickActions';
import AlertsPanel from '../components/dashboard/AlertsPanel';
import PageHeader from '../components/ui/PageHeader';
import { dataFetch } from '../api';

const Dashboard = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({
    learners: [],
    campaigns: [],
    complianceRecords: [],
    phishingSimulations: [],
    assignments: [],
    auditLogs: []
  });

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        const [learnersRes, campaignsRes, complianceRes, phishingRes, assignRes, auditRes] = await Promise.all([
          dataFetch('read/employees'),
          dataFetch('read/campaigns'),
          dataFetch('read/compliance_records'),
          dataFetch('read/phishing_simulations'),
          dataFetch('read/assignments'),
          dataFetch('read/audit_logs')
        ]);
        
        setData({
          learners: learnersRes?.data ?? [],
          campaigns: campaignsRes?.data ?? [],
          complianceRecords: complianceRes?.data ?? [],
          phishingSimulations: phishingRes?.data ?? [],
          assignments: assignRes?.data ?? [],
          auditLogs: auditRes?.data ?? []
        });
      } catch (err) {
        console.error("Error fetching dashboard data:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchDashboardData();
  }, []);

  const today = new Date().toLocaleDateString('en-US', {
    weekday: 'long', year: 'numeric', month: 'long', day: 'numeric',
  });

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-slate-800"></div>
      </div>
    );
  }

  return (
    <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.3 }} className="space-y-6 max-w-[1400px] mx-auto">
      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-end gap-4">
        <PageHeader
          eyebrow="Overview"
          title="Security Dashboard"
          description="Real-time snapshot of training, phishing resilience and compliance."
        />
        <p className="text-xs text-slate-400 font-medium pb-1 font-mono flex-shrink-0">{today}</p>
      </div>

      <DashboardMetrics data={data} />

      <div className="grid grid-cols-1 xl:grid-cols-4 gap-5 mt-2">
        <div className="xl:col-span-3">
          <DashboardCharts data={data} />
        </div>
        <div className="space-y-5">
          <QuickActions />
          <AlertsPanel data={data} />
        </div>
      </div>
    </motion.div>
  );
};

export default Dashboard;